import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

export default function PortalLayout({ children }) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#f8fafd] dark:bg-[#121212] text-[#202124] dark:text-[#e8eaed] font-sans antialiased flex">
      <div className="hidden lg:block shrink-0">
        <Sidebar isCollapsed={isSidebarCollapsed} />
      </div>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden flex">
          <div className="fixed inset-0 bg-black/50 backdrop-blur-xs" onClick={() => setIsMobileMenuOpen(false)} />
          <div className="relative z-50 w-64 h-full">
            <Sidebar isCollapsed={false} onNavigate={() => setIsMobileMenuOpen(false)} />
          </div>
        </div>
      )}

      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${isSidebarCollapsed ? 'lg:ml-[72px]' : 'lg:ml-64'}`}>
        <Header
          onMenuClick={() => setIsMobileMenuOpen(true)}
          isSidebarCollapsed={isSidebarCollapsed}
          onToggleSidebar={() => setIsSidebarCollapsed((c) => !c)}
        />

        <main className="flex-1 w-full p-4 sm:p-6 lg:p-8">
          <div className="page-enter">{children}</div>
        </main>
      </div>
    </div>
  );
}
